import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FeatureGroup, Polygon } from 'react-leaflet'
import { EditControl } from 'react-leaflet-draw'

import { utils } from 'parking-react-common'

import { map, join, uniqBy, has, isFunction } from 'lodash'

class MapPolygonsList extends Component {
    handleChange() {
        const { isEditable, onChange } = this.props

        if (!isEditable || !this.node || !isFunction(onChange)) {
            return
        }

        const geoJsonData = this.node.leafletElement.toGeoJSON()
        const geometries = utils.asGeometriesArray(geoJsonData)
        const newData = uniqBy(geometries, ({ geometry }) => join(geometry.coordinates))
        onChange(newData)
    }

    render() {
        const { data, color, isEditable } = this.props

        return (
            <FeatureGroup
                ref={ (ref) => {
                    this.node = ref
                } }
            >
                { isEditable && (
                    <EditControl
                        position="topright"
                        onEdited={ (e) => this.handleChange(e) }
                        onCreated={ (e) => this.handleChange(e) }
                        onDeleted={ (e) => this.handleChange(e) }
                        draw={ { circle: false, marker: false, circlemarker: false, polyline: false } }
                        edit={ { edit: { selectedPathOptions: { maintainColor: true, fillOpacity: 0.5 } } } }
                    />
                ) }
                { map(data, (polygon) => {
                    if (!has(polygon, 'geometry.coordinates')) {
                        return null
                    }

                    const positions = map(
                        polygon.geometry.coordinates,
                        (item) => map(item, (c) => ({ lat: c[1], lng: c[0] }))
                    )

                    return (
                        <Polygon
                            key={ join(polygon.geometry.coordinates, '-') }
                            positions={ positions }
                            fillOpacity={ 0.5 }
                            color={ color }
                            weight={ 1 }
                        />
                    )
                }) }
            </FeatureGroup>
        )
    }
}

MapPolygonsList.propTypes = {
    isEditable : PropTypes.bool,
    onChange   : PropTypes.func,
    data       : PropTypes.arrayOf(PropTypes.object),
    color      : PropTypes.string
}

MapPolygonsList.defaultProps = {
    color: '#4285f4'
}

export default MapPolygonsList
